import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const PhoneLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  paddingRigth: "5px",
  marginRigth: "5px",
  lineHeight: "0",
};
const imgSocial = {
  paddingRight: "10px",
  objectFit: "contain",
  transform: "translateY(5px)",
};

export default function Linkedin({linkedin}) {
  const linkedinUrl = linkedin.startsWith('http://') || linkedin.startsWith('https://')
  ? linkedin
  : `https://${linkedin}`;

  return (
    <a href={linkedinUrl}
      style={PhoneLink}
    >
      <img
        style={imgSocial}
        src={`https://files.myclientisrich.com/${client}/linkedin.png`}
        alt="logo linkdedin"
        width="20"
        height="20"
      ></img>
    </a>
  );
}
